<template>
  <div class="no-data" :style="{'padding-top': pt + 'px'}">
    <img :src="noData">
    <p>{{tip}}</p>
  </div>
</template>

<script>
  import noData from '@/assets/images/order/no-data.png'
  export default {
    name: 'withoutData',
    props: {
      tip: {
        type: String,
        default: '暂时没有数据'
      },
      pt: {
        type: Number,
        default: 150
      }
    },
    data () {
      return {
        noData
      }
    }
  }
</script>

<style lang="scss" scoped>
 .no-data {
   position: relative;
   width: 100%;
   text-align: center;
   color: #333;
   font-size: 18px;
   img {
     width: 30%;
     margin-bottom: 30px;
   }
 }
</style>
